import { Action } from "@ngrx/store";
import { CumpleFilterDates, MensajeCumple, UsuarioCumple, UsuarioFuncion } from "src/common/cumples";

export enum CumplesActionTypes {
	CumplesClearRequested = '[Cumples Component] Cumples Clear Requested',

	// Listado related actions
	CumplesRequested = '[Cumples Component] Cumples Requested',
	CumplesLoaded = '[Cumples API] Cumples Loaded',
	CumplesCancelled = '[Cumples API] Cumples Cancelled',

	// Mensaje related actions
	MensajeCumpleRequested = '[Cumples Component] Mensaje Cumple Requested',
	MensajeCumpleCreated = '[Cumples API] Mensaje Cumple Created',
	MensajeCumpleCancelled = '[Cumples API] Mensaje Cumple Cancelled',
	// Foto related actions
	UsuarioFotoRequested = '[Cumples API] Usuario Foto Requested',
	UsuarioFotoLoaded = '[Cumples API] Usuario Foto Loaded',
	UsuarioFotoCancelled = '[Cumples API] Usuario Foto Cancelled',
	UsuarioFotoDoNothing = '[Cumples API] Usuario Foto Do Nothing',
	// Filter related actions
	CumplesInitFilterRequested = '[Cumples Component] Init Filter Requested',
	CumplesInitFilterLoaded = '[Cumples API] Init Filter Loaded',
	CumplesInitFilterCancelled = '[Cumples API] Init Filter Cancelled',
	CumplesFilterChangeRequested = '[Cumples Component] Filter Change Requested',
	CumplesFilterChangeDone = '[Cumples API] Filter Change Done',
	// Funciones related actions
	UsuarioFuncionesRequested = '[Cumples Component] Usuario Funciones Requested',
	UsuarioFuncionesLoaded = '[Cumples API] Usuario Funciones Loaded',
	UsuarioFuncionesCancelled = '[Cumples API] Usuario Funciones Cancelled'
}

export class CumplesClearRequested implements Action {
	readonly type: string = CumplesActionTypes.CumplesClearRequested;
	constructor() {
	}
}

// Listado related actions
export class CumplesRequested implements Action {
	readonly type: string = CumplesActionTypes.CumplesRequested;
	constructor() {
	}
}

export class CumplesLoaded implements Action {
	readonly type: string = CumplesActionTypes.CumplesLoaded;
	constructor( public payload: { cumples: UsuarioCumple[] } ) {
	}
}

export class CumplesCancelled implements Action {
	readonly type: string = CumplesActionTypes.CumplesCancelled;
	constructor() {
	}
}

// Mensaje related Actions
export class MensajeCumpleRequested implements Action {
	readonly type: string = CumplesActionTypes.MensajeCumpleRequested;
	constructor( public payload: MensajeCumple ) {
	}
}

export class MensajeCumpleCreated implements Action {
	readonly type: string = CumplesActionTypes.MensajeCumpleCreated;
	constructor( public payload: MensajeCumple ) {
	}
}

export class MensajeCumpleCancelled implements Action {
	readonly type: string = CumplesActionTypes.MensajeCumpleCancelled;
	constructor() {
	}
}

// Foto related actions
export class UsuarioFotoRequested implements Action {
	readonly type: string = CumplesActionTypes.UsuarioFotoRequested;
	constructor( public payload: { idUsuarioMf: number } ) {
	}
}

export class UsuarioFotoLoaded implements Action {
	readonly type: string = CumplesActionTypes.UsuarioFotoLoaded;
	constructor( public payload: { idUsuarioMf: number, foto: string } ) {
	}
}

export class UsuarioFotoCancelled implements Action {
	readonly type: string = CumplesActionTypes.UsuarioFotoCancelled;
	constructor( public payload: { idUsuarioMf: number } ) {
	}
}

export class UsuarioFotoDoNothing implements Action {
	readonly type: string = CumplesActionTypes.UsuarioFotoDoNothing;
	constructor() {
	}
}

// Filter related actions
export class CumplesInitFilterRequested implements Action {
	readonly type: string = CumplesActionTypes.CumplesInitFilterRequested;
	constructor() {
	}
}

export class CumplesInitFilterLoaded implements Action {
	readonly type: string = CumplesActionTypes.CumplesInitFilterLoaded;
	constructor( public payload: { filterDates: CumpleFilterDates } ) {
	}
}

export class CumplesInitFilterCancelled implements Action {
	readonly type: string = CumplesActionTypes.CumplesInitFilterCancelled;
	constructor() {
	}
}

export class CumplesFilterChangeRequested implements Action {
	readonly type: string = CumplesActionTypes.CumplesFilterChangeRequested;
	constructor( public payload: { date: string } ) {
	}
}

export class CumplesFilterChangeDone implements Action {
	readonly type: string = CumplesActionTypes.CumplesFilterChangeDone;
	constructor( public payload: { date: string } ) {
	}
}

// Funciones related actions
export class UsuarioFuncionesRequested implements Action {
	readonly type: string = CumplesActionTypes.UsuarioFuncionesRequested;
	constructor( public payload: { idUsuarioMf: number } ) {
	}
}

export class UsuarioFuncionesLoaded implements Action {
	readonly type: string = CumplesActionTypes.UsuarioFuncionesLoaded;
	constructor( public payload: { funciones: UsuarioFuncion[], idUsuarioMf: number } ) {
	}
}

export class UsuarioFuncionesCancelled implements Action {
	readonly type: string = CumplesActionTypes.UsuarioFuncionesCancelled;
	constructor() {
	}
}


export type CumplesActions = CumplesClearRequested | CumplesRequested | CumplesLoaded | CumplesCancelled |
	MensajeCumpleRequested | MensajeCumpleCreated | MensajeCumpleCancelled |
	UsuarioFotoRequested | UsuarioFotoLoaded | UsuarioFotoCancelled | UsuarioFotoDoNothing |
	CumplesInitFilterRequested | CumplesInitFilterLoaded | CumplesInitFilterCancelled |
	CumplesFilterChangeRequested | CumplesFilterChangeDone |
	UsuarioFuncionesRequested | UsuarioFuncionesLoaded | UsuarioFuncionesCancelled;